export const trustBadges = [
  { icon: 'download', label: 'Instant Download' },
  { icon: 'lock', label: 'Secure Payment' },
  { icon: 'file', label: 'PDF Format' },
  { icon: 'shield', label: '7-Day Guarantee' },
]

export const socialStats = [
  { icon: 'users', value: '+500', label: 'Coaches' },
  { icon: 'layers', value: '6 + 5', label: 'Volumes & Bonuses' },
  { icon: 'star', value: '4.9/5', label: 'Average Rating' },
]

export const topReviews = [
  {
    quote:
      'I planned my whole competition season in one afternoon. Every practice now has a purpose and my athletes can feel the difference.',
    name: 'Ashley R.',
    role: 'High School Cheer Coach',
  },
  {
    quote:
      'The stunt progressions alone were worth it. My bases and flyers finally build the same way every single week.',
    name: 'Marisol G.',
    role: 'All Star Level 3 Coach',
  },
  {
    quote:
      'I used to write practice plans at midnight. Now I open the volume I need and walk into the gym ready.',
    name: 'Danielle K.',
    role: 'Youth Rec Program Director',
  },
]

export const problems = [
  'You spend hours preparing training before every session.',
  'You improvise stunt progressions and hope they hold.',
  'You have no safety or emergency protocol written down.',
  "You repeat the same drills because you've run out of ideas.",
  "You don't know how to structure a full season.",
  'Tryouts always turn into chaos.',
]

export const brandChips = [
  { value: '360+', label: 'Pages' },
  { value: '200+', label: 'Drills' },
  { value: '101', label: 'Activities' },
  { value: 'All', label: 'Levels' },
]

export const levelTags = [
  'Level 1',
  'Level 2',
  'Level 3',
  'Level 4',
  'Level 5',
  'Level 6',
]

export const volumes = [
  {
    tag: 'VOLUME 01',
    title: 'Foundations & Safety',
    description: 'The base every squad is built on.',
    bullets: [
      'Motion technique and body control',
      'Spotting fundamentals for every skill',
      'Written emergency and injury protocols',
    ],
  },
  {
    tag: 'VOLUME 02',
    title: 'Jumps & Motions',
    description: 'Sharpness, height and synchronization.',
    bullets: [
      'Flexibility and power blocks by week',
      'Jump drills with measurable checkpoints',
      'Cleaning sequences for full-squad sync',
    ],
  },
  {
    tag: 'VOLUME 03',
    title: 'Tumbling Progressions',
    description: 'Safe, stepped skill building.',
    bullets: [
      'Skill trees from standing BHS to full',
      'Drill stations for mixed-ability groups',
      'Readiness checklists before you progress',
    ],
  },
  {
    tag: 'VOLUME 04',
    title: 'Stunts & Pyramids',
    description: 'Legal progressions level by level.',
    bullets: [
      'Stunt builds for Levels 1 through 6',
      'Pyramid diagrams with entries and exits',
      'Troubleshooting for the most common bobbles',
    ],
  },
  {
    tag: 'VOLUME 05',
    title: 'Routine & Performance',
    description: 'Choreography, counts and stage presence.',
    bullets: [
      '8-count routine frameworks you can reuse',
      'Formation changes and transition library',
      'Facials, projection and crowd appeal work',
    ],
  },
  {
    tag: 'VOLUME 06',
    title: 'Coaching & Team Management',
    description: 'Season planning, communication, leadership.',
    bullets: [
      'Full-season calendar and practice templates',
      'Parent and athlete communication scripts',
      'Culture, captains and conflict resolution',
    ],
  },
]

export const volumeFeatureTags = [
  'Annual Planning',
  'Complete Sessions',
  'Ready-to-Use Diagrams',
  'Skill Progressions',
  'Safety Protocols',
  'Printable Templates',
]

export const bonuses = [
  {
    tag: 'BONUS 01',
    title: "The Cheer Coach's Season Planner",
    description: '36 weeks planned, week by week.',
    image:
      'https://cdn.magicpatterns.com/uploads/rPzp8njj6c2V6eCYeeWonr/Captura_de_pantalla_2026-09-16_a_la(s)_12.20.23_p._m..png',
    imageAlt: "The Cheer Coach's Season Planner book cover",
  },
  {
    tag: 'BONUS 02',
    title: 'The Tryouts & Team Selection Kit',
    description: 'Score it, place it, announce it.',
    image:
      'https://cdn.magicpatterns.com/uploads/qc3bRDRmByxJXLMaGaH6LH/Captura_de_pantalla_2026-09-16_a_la(s)_12.20.33_p._m..png',
    imageAlt: 'The Tryouts & Team Selection Kit book cover',
  },
  {
    tag: 'BONUS 03',
    title: 'Game Day Playbook',
    description: '40 sideline chants and cheers, written out in full.',
    image:
      'https://cdn.magicpatterns.com/uploads/oqE1iY1pCtJPp743g5ZJm5/Captura_de_pantalla_2026-09-16_a_la(s)_12.20.43_p._m..png',
    imageAlt: 'Game Day Playbook book cover',
  },
  {
    tag: 'BONUS 04',
    title: 'Stunt Safety & Spotting Emergency Guide',
    description: 'Recognize, respond, document.',
    image:
      'https://cdn.magicpatterns.com/uploads/4dSUBUZJTLNHrxoMu5FQQw/Captura_de_pantalla_2026-09-16_a_la(s)_12.20.55_p._m..png',
    imageAlt: 'Stunt Safety & Spotting Emergency Guide book cover',
  },
  {
    tag: 'BONUS 05',
    title: 'Flexibility & Injury Prevention Program',
    description: '12 weeks, four days a week.',
    image:
      'https://cdn.magicpatterns.com/uploads/ewXFX81dTaG69zDGMN81ge/Captura_de_pantalla_2026-09-16_a_la(s)_12.21.04_p._m..png',
    imageAlt: 'Flexibility & Injury Prevention Program book cover',
  },
]

export const pricingIncludes = [
  '6 Complete Volumes',
  '5 Strategic Bonuses',
  '360+ Pages',
  'Instant PDF Download',
  'Lifetime Updates',
  'Print-Ready Files',
]

export const upsellFeatures = [
  {
    icon: 'grid',
    title: 'Advanced 8-count diagrams',
    description: 'Every count mapped on the mat so nobody guesses their spot.',
  },
  {
    icon: 'shuffle',
    title: 'Professional transition library',
    description: 'Plug-and-play movements between sections of the routine.',
  },
  {
    icon: 'users',
    title: 'Formation change templates',
    description: 'Editable floor maps for 12, 16, 20 and 24 athletes.',
  },
  {
    icon: 'music',
    title: 'Music and count mapping',
    description: 'Hit every beat with a written breakdown of your mix.',
  },
]

export const testimonials = [
  {
    initials: 'AR',
    quote:
      'My athletes stopped plateauing the week I started using the tumbling progressions. Everything is stepped, so I always know what comes next and why.',
    name: 'Ashley R.',
    role: 'High School Cheer Coach',
  },
  {
    initials: 'MG',
    quote:
      'Our stunt groups are cleaner and safer. Having legal progressions written down by level took all the guesswork out of my practices.',
    name: 'Marisol G.',
    role: 'All Star Level 3 Coach',
  },
  {
    initials: 'DK',
    quote:
      'Tryouts used to wreck me. The selection kit gave me a scoring sheet, a placement chart and a script for the hard conversations.',
    name: 'Danielle K.',
    role: 'Youth Rec Program Director',
  },
  {
    initials: 'TB',
    quote:
      'First year coaching and I walked in with a full season planned. Parents noticed, my athletes noticed, and I stopped second-guessing myself.',
    name: 'Tori B.',
    role: 'Middle School Cheer Coach',
  },
  {
    initials: 'JS',
    quote:
      'The safety and spotting guide is now printed and posted in our gym. It is the single best coaching document I own.',
    name: 'Jenna S.',
    role: 'All Star Gym Owner',
  },
  {
    initials: 'CP',
    quote:
      'We used the routine frameworks for two competitions this season and placed in both. The formation library saved me hours of choreography.',
    name: 'Camila P.',
    role: 'Competitive Team Coach',
  },
]

export const faqs = [
  {
    question: 'What exactly is Cheerleading Ready 360?',
    answer:
      'It is a complete digital coaching toolkit: six PDF volumes plus five bonuses covering 360+ pages of sessions, drills, stunt and tumbling progressions, routine frameworks, safety protocols and team management tools. Everything is written, diagrammed and ready to run.',
  },
  {
    question: 'How does it work, do I get access right away?',
    answer:
      'Yes. The moment your payment goes through you get an email with your download links. No waiting, no shipping, no account to set up.',
  },
  {
    question: 'What levels does it cover?',
    answer:
      'Levels 1 through 6, plus rec, school and all star settings. Every progression is broken down so you can start a skill safely and know exactly what the next step looks like.',
  },
  {
    question: 'Are the bonuses really included?',
    answer:
      'All five bonuses are included at no extra cost during the launch. That is the season planner, tryouts kit, game day playbook, safety guide and flexibility program.',
  },
  {
    question: 'Is it suitable for beginner coaches?',
    answer:
      'Especially. Every session is explained step by step with the coaching cues, common errors and safety checks written out, so you can run a professional practice in your first season.',
  },
  {
    question: 'Can I print the material?',
    answer:
      'Yes. Every file is print-ready, and the planners, score sheets and templates are designed to be printed and used on a clipboard at the gym.',
  },
  {
    question: 'Is the content aligned with USASF rules?',
    answer:
      'Progressions reference the USASF All Star Cheer Rules as updated May 2026. Rules change, so always confirm the current requirements with your governing body before running a skill.',
  },
  {
    question: "What if it's not for me?",
    answer:
      'You have seven days. Open everything, use it at practice, and if it is not what you expected we refund you in full, no questions asked.',
  },
]

export const footerLinks = [
  { label: 'Terms', href: '#' },
  { label: 'Privacy', href: '#' },
  { label: 'Contact', href: 'mailto:support@cheerleadingready360.com' },
]
